import { effect, inject } from '@angular/core';
import { LanguageService } from './language.service';

/**
 * Runs `reload` whenever the active UI language changes — never on first render.
 *
 * A fallback for components that fetch translatable data imperatively and cannot
 * (yet) consume a service's active-locale stream directly. Prefer reading a
 * locale-keyed service stream (e.g. `toSignal(service.xxx$)`), which becomes
 * locale-reactive with no component code at all; reach for this only when an
 * imperative, order-dependent fetch chain can't be safely converted.
 *
 * Must be called from an injection context (a component/directive constructor or
 * field initializer). The underlying effect is cleaned up automatically when the
 * enclosing context is destroyed.
 */
export function reloadOnLocaleChange(reload: () => void): void {
  const languageService = inject(LanguageService);
  let previousLanguageKey = languageService.activeLanguage().languageKey;

  effect(() => {
    const languageKey = languageService.activeLanguage().languageKey;
    if (languageKey !== previousLanguageKey) {
      previousLanguageKey = languageKey;
      reload();
    }
  });
}
